import {numUtil} from './num';

function formatDate(t) {
  const time = new Date(t);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return [y, m, d].map(numUtil.pad).join('-');
}

function formatDateWithSlashes(t) {
  const time = new Date(t);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return [y, m, d].map(numUtil.pad).join('/');
}

function formatTime(t) {
  const time = new Date(t);
  const h = time.getHours();
  const m = time.getMinutes();
  const s = time.getSeconds();
  return [h, m, s].map(numUtil.pad).join(':');
}

function formatHourMin(t) {
  const time = new Date(t);
  const h = time.getHours();
  const m = time.getMinutes();
  return [h, m].map(numUtil.pad).join(':');
}

function formatUTCHourMin(t) {
  const time = new Date(t);
  const h = time.getUTCHours();
  const m = time.getUTCMinutes();
  return [h, m].map(numUtil.pad).join(':');
}

function formatUTCMonthDay(t, mark) {
  const time = new Date(t);
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [m, d].map(numUtil.pad).join(mark || '/');
}

function formatMonthDay(t, mark) {
  const time = new Date(t);
  const m = time.getMonth() + 1;
  const d = time.getDate();
  return [m, d].map(numUtil.pad).join(mark || '/');
}

function formatMonthTime(t) {
  const time = new Date(t);
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  return [[m, d].map(numUtil.pad).join('-'), [h, mm].map(numUtil.pad).join(':')].join(' ');
}

function formatDateTime(t) {
  return [formatDate(t), formatTime(t)].join(' ');
}

function formatDateTimeSlash(t) {
  return [formatDateWithSlashes(t), formatTime(t)].join(' ');
}

function formatUTCDate(t) {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [y, m, d].map(numUtil.pad).join('-');
}

function formatUTCTime(t) {
  const time = new Date(t);
  const h = time.getUTCHours();
  const m = time.getUTCMinutes();
  const s = time.getUTCSeconds();
  return [h, m, s].map(numUtil.pad).join(':');
}

function formatUTCDateTime(t) {
  return [formatUTCDate(t), formatUTCTime(t)].join(' ');
}

function formatUTCDateSlash(t) {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [y, m, d].map(numUtil.pad).join('/');
}

function formatUTCDateDot(t) {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [y, m, d].map(numUtil.pad).join('.');
}

function formatUTCDateReverse(t) {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [d, m, y].map(numUtil.pad).join('/');
}

function formatUTCDateTimeSlash(t) {
  return [formatUTCDateSlash(t), formatUTCTime(t)].join(' ');
}

function formatUTCDateWestPattern(t) {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const m = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  return [d, m, y].map(numUtil.pad).join('.');
}

function formatUTCDateKevin(t) {
  const time = new Date(t);
  const y = time.getUTCFullYear();
  const M = time.getUTCMonth() + 1;
  const d = time.getUTCDate();
  const h = time.getUTCHours();
  const m = time.getUTCMinutes();
  const dayTime = [h, m].map(numUtil.pad).join(':');
  const yearTime = [M, d, y].map(numUtil.pad).join('/');
  return [dayTime, yearTime].join(' ');
}

function formatYearMonth(t, mark = '-') {
  return t.replace(new RegExp('^(\\d{4})', 'g'), `$1${mark}`)
}

export const timeUtil = {
  formatDate,
  formatDateWithSlashes,
  formatTime,
  formatDateTime,
  formatDateTimeSlash,
  formatUTCDate,
  formatUTCTime,
  formatUTCDateTime,
  formatHourMin,
  formatUTCHourMin,
  formatMonthDay,
  formatUTCMonthDay,
  formatMonthTime,
  formatUTCDateSlash,
  formatUTCDateDot,
  formatUTCDateTimeSlash,
  formatUTCDateWestPattern,
  formatUTCDateReverse,
  formatUTCDateKevin,
  formatYearMonth,
};
